import React from 'react';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@material-ui/icons/Close';
import Modal from 'components/Common/Modal/Modal';

import styles from './ModalPageContent.module.scss';

function ModalPageContent({
  isOpen,
  closeModal,
  pageUrl,
}: {
  isOpen: boolean;
  closeModal: () => void;
  pageUrl: string;
}): JSX.Element | null {
  if (!isOpen) {
    return null;
  }
  const { t } = useTranslation();

  return (
    <Modal isOpen={true}>
      <div className={styles.modal}>
        <div className={styles.modalHeader}>
          <button
            type="button"
            className={styles.modalCloseButton}
            onClick={closeModal}
            aria-label={t('LABEL_CLOSE')}
          >
            <CloseIcon />
          </button>
        </div>
        <div
          className={styles.modalBody}
          dangerouslySetInnerHTML={{
            __html: `<iframe src="${pageUrl}" />`,
          }}
        ></div>
      </div>
    </Modal>
  );
}

export default ModalPageContent;
